import { Entity, SystemInterface } from '@goodboydigital/odie';

import { Game } from '../Game';

export class DebugSystem implements SystemInterface
{
    public game: Game;
    public stats: HTMLDivElement;
    private updateCount = 0;

    constructor(entity: Entity)
    {
        this.game = entity.scene as Game;

        this.stats = document.createElement('div');
        this.stats.style.position = 'fixed';
        this.stats.style.width = '150px';
        this.stats.style.height = '100%';
        this.stats.style.background = 'rgba(0, 0, 0, 0.6)';
        this.stats.style.pointerEvents = 'none';
        this.stats.style.color = '#EEEEEE';
        this.stats.style.padding = '10px';
        this.stats.style.paddingTop = '60px';
        this.stats.style.fontFamily = 'Roboto,sans-serif';
        this.stats.style.fontSize = '0.75em';
        document.body.appendChild(this.stats);
    }

    public update(): void
    {
        if (this.updateCount--) return;
        this.updateCount = 60;

        const text = [
            objToHtmlStr(this.game.physics.getProfile()),
            objToHtmlStr(this.game.level.getProfile()),
            objToHtmlStr(this.game.race.getProfile()),
            objToHtmlStr(this.game.garage.getProfile()),
        ];

        this.stats.innerHTML = text.join('');
    }
}

function objToHtmlStr(obj: any, fields?: string[]): string
{
    if (!fields) fields = Object.keys(obj);
    let str = '';

    for (const i in fields)
    {
        const k = fields[i];
        let v = obj[k];

        if (typeof (v) === 'number' && v % 1 !== 0) v = v.toFixed(3);
        str += `<b style="color:#FFFFFF">${k}:</b> <span style="color:#AAAAAA">${v || '---'}</span><br/>`;
    }

    return `${str}`;
}
